import get from 'lodash.get'

export const getInitialExpandedState = (data, initialExpandDepth, getSubRows) => {
  if (initialExpandDepth === null || initialExpandDepth === undefined) {
    return true
  }

  if (initialExpandDepth === 0) {
    return {}
  }

  // Expand rows up to the specified depth
  return getRowIdsUpToDepth(data, initialExpandDepth, getSubRows)
}

const getRowIdsUpToDepth = (data, maxDepth, getSubRows, currentDepth = 0, parentId = '', expanded = {}) => {
  if (currentDepth >= maxDepth) {
    return expanded
  }

  data.forEach((row, index) => {
    const rowId = parentId ? `${parentId}.${index}` : `${index}`
    expanded[rowId] = true

    const subRows = getSubRows(row)
    if (subRows && subRows.length > 0) {
      getRowIdsUpToDepth(subRows, maxDepth, getSubRows, currentDepth + 1, rowId, expanded)
    }
  })

  return expanded
}

/**
 * Creates a cell context for sibling row data that's compatible with react-table's flexRender
 */
export const createSiblingCellContext = (sibling, originalCell, parentRow, siblingIndex) => {
  const columnDef = originalCell.column.columnDef
  const accessorKey = columnDef.accessorKey || columnDef.accessor

  // Get the value using lodash.get for deep property access
  const siblingValue = accessorKey ? get(sibling, accessorKey) : undefined

  const siblingRowId = `${parentRow.id}-sibling-${siblingIndex}`

  return {
    getValue: () => siblingValue,
    renderValue: () => siblingValue,
    row: {
      original: sibling,
      index: siblingIndex,
      id: siblingRowId,
      depth: parentRow.depth + 1,
      getVisibleCells: () => [],
      getAllCells: () => []
    },
    column: originalCell.column,
    cell: {
      ...originalCell,
      id: `${originalCell.id}-sibling-${siblingIndex}`,
      row: {
        original: sibling,
        index: siblingIndex,
        id: siblingRowId
      },
      getValue: () => siblingValue,
      renderValue: () => siblingValue
    },
    table: originalCell.table
  }
}
